import request from '@/utils/request2';

// 编辑个人信息
export function editPersonalInformationCustomer(data) {
  return request.post('admin/user/edit-personal-information', data);
}